import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Highlighter from 'react-highlight-words';
import Api from '../../services/ApiService';
import ListSearch from '../list/ListSearch';
import { FormContainerContext } from '../form/Form';

const MultiListSearch = props => {
  const { pageName, command = 'LIST', limit = 25, filter, setLoading = () => {} } = props;
  const { branchId } = useContext(FormContainerContext);

  const getList = value => {
    const params = {
      cmd: command,
      q: value || '',
      limit,
      filter,
    };

    if (branchId) {
      params.useBranchId = branchId;
    }

    return Api.get(`list/${pageName}/multiSearch`, { params });
  };

  const loadSuggestions = value => {
    setLoading(true);

    return getList(value).then(res => {
      setLoading(false);
      return Promise.resolve(res.data.list);
    });
  };

  const renderSuggestion = (suggestion, { query }) => {
    // Support for literal string suggestion
    if (suggestion && typeof suggestion !== 'object') {
      return <span>{suggestion}</span>;
    }

    if (suggestion.selectAll) {
      return <div style={{ fontWeight: 'bold' }}>Select All</div>;
    }

    const suggestionKeys = Object.keys(suggestion);
    const itemid = suggestionKeys[0];
    const name = suggestion.Name ? 'Name' : suggestionKeys[1];

    // Grab the first key after itemid
    // const name = _.without(Object.keys(suggestion), 'itemid')[0];
    const terms = query.replace(':', '').split(/\s/);

    const text = !suggestion[name] ? suggestion[itemid] : `${suggestion[itemid]}: ${suggestion[name]}`;

    return <Highlighter autoEscape highlightClassName="hl" searchWords={terms} textToHighlight={text} />;
  };

  return <ListSearch {...props} loadSuggestions={loadSuggestions} renderSuggestion={renderSuggestion} />;
};

MultiListSearch.propTypes = {
  command: PropTypes.string,
  filter: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  limit: PropTypes.number,
  pageName: PropTypes.string,
  setLoading: PropTypes.func,
};

export default MultiListSearch;
